import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { confirmAlert } from "react-confirm-alert";
import { BASE_IMAGES_URL, COMMON_FAIL_MESSAGE } from "Constants";
import { showError, showSuccess } from "ReduxErrorBar";
import Badge from "react-bootstrap/Badge";
import {
  communityModal,
  editCommunity,
  deleteCommunity,
} from "ActionsCommunity";
import LocaleStrings from "Languages";

class ListItem extends Component {
  constructor(props) {
    super(props);
  }

  edit = () => {
    var { listItem } = this.props;
    this.props.editCommunity(listItem);
    this.props.communityModal({ showModal: true });
  };

  delete = () => {
    var { session, listItem, currentPage, pageDataLength } = this.props;
    let pageNo = currentPage;
    if (pageDataLength == 1) {
      pageNo = pageNo - 1;
    }

    confirmAlert({
      title: LocaleStrings.delete,
      message: LocaleStrings.content_community_text_delete_subtitle,
      confirmLabel: LocaleStrings.button_ok,
      cancelLabel: LocaleStrings.button_cancel,
      buttons: [
        {
          label: LocaleStrings.button_ok,
          onClick: () => {
            this.props.deleteCommunity(
              session,
              listItem.communitycategoryid,
              (result) => {
                if (result.error) {
                  this.props.showError(COMMON_FAIL_MESSAGE);
                } else {
                  this.props.showSuccess(
                    LocaleStrings.content_community_delete_success
                  );
                  this.props.pagination(pageNo);
                  this.props.contentBoardStatus();
                }
              }
            );
          },
        },
        {
          label: LocaleStrings.button_cancel,
          onClick: () => {},
        },
      ],
    });
  };

  render() {
    var { listItem, session } = this.props;
    var icon = "";
    // categoryicon
    var imgURL = "../../style/images/placeholder_600x400.svg";
    if (listItem.categoryicon) {
      if (
        listItem.categoryicon.endsWith(".jpg") ||
        listItem.categoryicon.endsWith(".png")
      ) {
        imgURL = `${BASE_IMAGES_URL}/${listItem.categoryicon}?api_key=${session.apiKey}&session_token=${session.sessionToken}`;
      } else {
        var parseIcon = JSON.parse(listItem.categoryicon);
        imgURL = "";
        icon = parseIcon.title;
      }
    }

    var style = {
      width: "30px",
      height: "30px",
      backgroundImage: `url(${imgURL})`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      borderRadius: "5px",
      backgroundPosition: "50% 50%",
      marginTop: "5px",
      marginBottom: "5px",
      marginRight: "10px",
    };

    return (
      <tr>
        <td>
          <div className="vertical-align-center">
            <div style={style}>
              <i className={icon} style={{ fontSize: "25px" }}></i>
            </div>
            <div className="vcenter">
              {parseInt(listItem.isprivate) ? (
                /* <i className="fa fa-lock" style={{ marginRight: 2 }}></i> */
                <img
                  src="../../style/images/custom-icons/private_bubble.svg"
                  style={{
                    marginRight: 2,
                    marginLift: 2,
                    marginBottom: 3,
                    width: 16,
                  }}
                />
              ) : (
                ""
              )}
              {listItem.categoryname}
              {listItem.description ? (
                <div className="custom-text2-secondary-normal">
                  {listItem.description}
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </td>
        <td className="text-capitalize">
          <p className="old-p-tag">{listItem.type}</p>
          {parseInt(listItem.isprivate) ? (
            <Badge pill bg="secondary">
              {LocaleStrings.content_community_form_category_option2}
            </Badge>
          ) : (
            <Badge pill bg="secondary">
              {LocaleStrings.content_community_form_category_option1}
            </Badge>
          )}
        </td>
        <td>{listItem.postcount == 0 ? "NA" : listItem.postcount}</td>
        <td>{listItem.commentcount == 0 ? "NA" : listItem.commentcount}</td>
        <td>
          <div className="action-button-area">
            <div className="action-button vcenter">
              <button
                className="btn btn-custom-table-white"
                onClick={this.edit}
              >
                {LocaleStrings.button_edit}
              </button>
            </div>
            <div className="action-button vcenter">
              <button className="i-custom-table-delete" onClick={this.delete}>
                <img
                  className="button-delete-icon"
                  src="../../style/images/delete.png"
                />
              </button>
            </div>
          </div>
        </td>
      </tr>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
  };
}
export default connect(mapStateToProps, {
  showError,
  showSuccess,
  communityModal,
  editCommunity,
  deleteCommunity,
})(ListItem);
